import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";

export default function Blog() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/content/articles").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const [featured, ...rest] = items;

  return (
    <div data-testid="blog-page">
      <PageHero
        eyebrow="Άρθρα / Blog"
        title="Ιδέες, πληροφορίες και περιεχόμενο."
        text="Γύρω από την επικοινωνία, τη γνωστική λειτουργία και την εκπαίδευση."
      />

      <section className="pb-24 sm:pb-32 bg-parch -mt-1 pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {featured && (
            <Reveal>
              <Link
                to={`/arthra/${featured.id}`}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-8 border-y-2 border-ink py-10 mb-16"
                data-testid="article-featured"
              >
                <div className="lg:col-span-7">
                  <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-terracottaD">{featured.category} — Επιλεγμένο</p>
                  <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.12] mt-4 transition-colors duration-300 group-hover:text-terracottaD">
                    {featured.title}
                  </h2>
                </div>
                <div className="lg:col-span-5 flex flex-col justify-between">
                  <p className="text-slate2 leading-relaxed text-sm sm:text-base">{featured.excerpt}</p>
                  <div className="flex items-center justify-between mt-6">
                    <p className="font-mono2 text-[10px] tracking-[0.15em] uppercase text-ink/45 flex items-center gap-2">
                      <CalendarDays className="w-3.5 h-3.5" /> {featured.date} {featured.read_time ? `• ${featured.read_time}` : ""}
                    </p>
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-terracottaD">
                      Διάβασε
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </div>
              </Link>
            </Reveal>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
            {rest.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 0.08}>
                <Link to={`/arthra/${a.id}`} className="group block" data-testid={`article-item-${i}`}>
                  <div className="border-t-2 border-ink pt-5 transition-colors duration-300 group-hover:border-terracotta">
                    <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-terracottaD">{a.category}</p>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold leading-snug mt-3 transition-colors duration-300 group-hover:text-terracottaD">
                      {a.title}
                    </h3>
                    <p className="text-slate2 text-sm leading-relaxed mt-3 line-clamp-3">{a.excerpt}</p>
                    <p className="font-mono2 text-[10px] tracking-[0.15em] uppercase text-ink/45 mt-5 flex items-center gap-2">
                      <CalendarDays className="w-3.5 h-3.5" /> {a.date} {a.read_time ? `• ${a.read_time}` : ""}
                    </p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>

          {loaded && items.length === 0 && (
            <p className="text-slate2 font-mono2 text-sm tracking-wider" data-testid="articles-empty">
              Δεν υπάρχουν άρθρα ακόμα.
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
